import Image from '@plone/volto/components/theme/Image/Image';
import ploneLogo from 'volto-uni-bonn/assets/plone-logo.svg';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Anontools from '@plone/volto/components/theme/Anontools/Anontools';
import 'volto-uni-bonn/theme/conference.css';

export default function Footer() {
  return (
    <footer id="footer" className="conference-footer" tabIndex="-1">
      <div className="ui container conference-footer__row">
        <div>
          <Image
            className="conference-plone-logo"
            src={ploneLogo}
            alt="Plone"
          />
          <p>Open source. Shared knowledge. A global community.</p>
        </div>
        <nav aria-label="Footer">
          <UniversalLink href="/about-plone">Discover Plone</UniversalLink>
          <UniversalLink href="/community">Community</UniversalLink>
          <UniversalLink href="/about">About this site</UniversalLink>
        </nav>
      </div>
      <div className="ui container conference-footer__bottom">
        <small>
          Lino demonstration by Interaktiv. Independent of the official Plone
          website.
        </small>
        <Anontools />
      </div>
    </footer>
  );
}
